export default "__VITE_ASSET__w2JdD$xE__"